export const radioGroupTypes = {
  simple: 'SIMPLE',
  advanced: 'ADVANCED'
} as const;
